export function HIDE_SPINNER() {
  return (Class: any) => {
    Object.defineProperty(Class.prototype, 'hideSpinner', {
      value: true,
    });
  };
}
